<template>
  <VisibilityLocations :variant="VisibilityLocationViewMode.ARCHIVED" />
</template>

<script lang="tsx" setup>
import VisibilityLocations from '@pages/visibility/visibilityLocation/VisibilityLocations.vue';
import { VisibilityLocationViewMode } from '@/entities/Entities';
</script>

<style lang="scss" scoped>
</style>
